
import {
  computed,
  defineComponent,
  ref,
} from 'vue';
import { useRoute, useRouter } from 'vue-router';
import useMonthPanel from '@/composables/useMonthPanel';
import { useStore } from '@/store';

export default defineComponent({
  name: 'CalendarBodyMonth',
  setup() {
    const weekList = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    // const monthList = ['一 月', '二 月', '三 月', '四 月', '五 月', '六 月', '七 月', '八 月', '九 月', '十 月', '十一月', '十二月'];
    // const monthList = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    const eMonthList = [
      { value: 'January', place: 'tw-top-1/2 tw-left-3 tw-rotate-105' },
      { value: 'February', place: 'tw-top-1/2 tw-left-2/3 tw-rotate-0' },
      { value: 'March', place: 'tw-top-20 tw--left-0 tw--rotate-45' },
      { value: 'April', place: 'my-animate-apr tw-top-1/2 tw-left-16 tw-rotate-90' },
      { value: 'May', place: 'my-animate-may tw-top-12 tw-left-12 tw--rotate-12' },
      { value: 'June', place: 'tw-bottom-36 tw-left-10 tw--rotate-12' },
      { value: 'July', place: 'my-animate-july tw-top-9 tw-left-11 tw-rotate-40' },
      { value: 'August', place: 'tw-top-20 tw--left-5 tw--rotate-105' },
      { value: 'September', place: 'my-animate-sep tw-top-20 tw-left-9 tw-rotate-105' },
      { value: 'ctober', place: 'my-animate-oct tw-top-36 tw-left-36 tw-rotate-0' },
      { value: 'November', place: 'my-animate-nov tw-top-28 tw-left-8 tw-rotate-90' },
      { value: 'December', place: 'tw-top-1/2 tw-left-32 tw-rotate-0' },
    ];
    // const monthList = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
    const monthList = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'];

    const showYearSelection = ref(false);
    const showMonthSelection = ref(false);

    const router = useRouter();
    const route = useRoute();
    const goToCalender = () => {
      router.push({ name: 'Calendar', params: { dateString: route.params.dateString } });
    };
    // @ts-ignore
    const date = computed(() => Number(route.params.dateString.split('-')[2]));
    const store = useStore();
    const day = computed(() => {
      const d = store.state.currentDate.date?.getDay();
      return d ? weekList[d] : '';
    });

    const { currentMonth, goToAddMonth } = useMonthPanel();

    return {
      monthList,
      eMonthList,
      currentMonth,
      showYearSelection,
      showMonthSelection,
      goToAddMonth,
      goToCalender,
      date,
      day,
    };
  },
});
